import { Link } from "react-router-dom";

function Brandsection({ Image }) {
  return (
    <Link to='/' className='item'>
      <img src={Image} />
    </Link>
  )
}
export default Brandsection;